import { FadeUp } from "./Reveal";
import { useLang } from "./LanguageContext";

const EXP_IMG = "/stage/experience-plates.webp";

const copy = {
  en: {
    kicker: "The Experience",
    h2: "Impeccable craft, restrained elegance, and a sense of occasion at every table.",
    body: "Every performance is tailored to the venue, so the experience always feels considered and personal. Ingredients are chosen for their provenance and quality, then presented with the restraint of true fine dining.",
    stats: [
      { v: "100%", l: "handcrafted tableside" },
      { v: "3", l: "ways to bring it to life" },
      { v: "0", l: "shortcuts, ever" },
      { v: "1:1", l: "bespoke to your venue" },
    ],
  },
  it: {
    kicker: "L'Esperienza",
    h2: "Mestiere impeccabile, eleganza sobria e senso dell'occasione a ogni tavolo.",
    body: "Ogni performance è pensata per la sala che la ospita, così l'esperienza risulta sempre curata e personale. Gli ingredienti sono scelti per provenienza e qualità, poi presentati con la sobrietà del vero fine dining.",
    stats: [
      { v: "100%", l: "fatta a mano al tavolo" },
      { v: "3", l: "modi per darle vita" },
      { v: "0", l: "scorciatoie, mai" },
      { v: "1:1", l: "su misura per la tua sala" },
    ],
  },
  ru: {
    kicker: "Опыт",
    h2: "Безупречное ремесло, сдержанная элегантность и чувство события за каждым столом.",
    body: "Каждое выступление создаётся под конкретное заведение, поэтому опыт всегда ощущается продуманным и личным. Ингредиенты выбраны за происхождение и качество, поданы со сдержанностью настоящего fine dining.",
    stats: [
      { v: "100%", l: "ручная работа у стола" },
      { v: "3", l: "способа воплотить" },
      { v: "0", l: "компромиссов" },
      { v: "1:1", l: "под ваше заведение" },
    ],
  },
  es: {
    kicker: "La Experiencia",
    h2: "Oficio impecable, elegancia sobria y sentido de ocasión en cada mesa.",
    body: "Cada actuación se adapta al salón que la recibe, para que la experiencia siempre se sienta cuidada y personal. Los ingredientes se eligen por su origen y calidad, y se presentan con la sobriedad del verdadero fine dining.",
    stats: [
      { v: "100%", l: "hecha a mano en la mesa" },
      { v: "3", l: "formas de darle vida" },
      { v: "0", l: "atajos, nunca" },
      { v: "1:1", l: "a medida para tu salón" },
    ],
  },
};

export const Experience = ({ ways = "3" }) => {
  const { lang } = useLang();
  const t = copy[lang];
  return (
    <section id="experience" className="py-24 md:py-40 bg-wine text-bg overflow-hidden" data-testid="experience-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end mb-16 md:mb-24">
          <FadeUp className="lg:col-span-7">
            <p className="font-sans text-xs uppercase tracking-[0.35em] text-bg/50 mb-6">{t.kicker}</p>
            <h2 className="font-serif text-4xl md:text-6xl leading-[1.05]">{t.h2}</h2>
          </FadeUp>
          <FadeUp className="lg:col-span-5" delay={0.15}>
            <p className="font-sans text-base md:text-lg text-bg/70 leading-relaxed">{t.body}</p>
          </FadeUp>
        </div>

        <FadeUp>
          <div className="relative aspect-[16/9] md:aspect-[21/9] overflow-hidden rounded-sm">
            <img src={EXP_IMG} alt="Intimate luxury fine-dining ambiance" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-wine/70 to-transparent" />
          </div>
        </FadeUp>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mt-16 md:mt-24 border-t border-bg/15 pt-12">
          {t.stats.map((s, i) => (
            <FadeUp key={s.l} delay={i * 0.08}>
              <p className="font-serif text-5xl md:text-6xl text-bg leading-none">{i === 1 ? ways : s.v}</p>
              <p className="font-sans text-xs uppercase tracking-[0.2em] text-bg/50 mt-3">{s.l}</p>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};
